import { css } from '@emotion/css';

const PAGINATION_BULLET_HEIGHT = 0.5;

export const carouselPaginationStyles = css`
  .pagination-bullet {
    width: 0.5rem;
    height: ${PAGINATION_BULLET_HEIGHT}rem;
    opacity: 1;
    transition: all;
    transition-duration: 200ms;
    background-color: var(--border-dark);
  }

  .pagination-bullet-active {
    width: 1.6rem;
    border-radius: ${PAGINATION_BULLET_HEIGHT / 2}rem;
    background-color: var(--interactive-primary);
  }
`;

export const arrowColorStyles = (color?: string) => css`
  fill: var(--${color === 'text-text-white' ? 'icon-white' : 'icon-active'});
  transition: fill;
  transition-duration: 100ms;
`;

export const bulletColorStyles = (color?: string) => css`
  .pagination-bullet-active {
    background-color: var(
      --${color === 'text-text-white' ? 'interactive-white' : 'interactive-primary'}
    );
  }
`;

export const paginationInSlide = css`
  position: relative;
  margin-top: -8.8rem;
  z-index: 100;
`;
